import { createSlice } from "@reduxjs/toolkit";
import {
  getAllActivePosition,
  insertJobApplication,
} from "./services/career.services";
import { ICareerState } from "./careerModel";

const initialState: ICareerState = {
  loading: false,
  applicationLoading: false,
  error: "",
  PositionList: [],
};

const careerSlice = createSlice({
  name: "career",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(insertJobApplication.pending, (state) => {
      state.applicationLoading = true;
      state.error = "";
    });
    builder.addCase(insertJobApplication.fulfilled, (state) => {
      state.applicationLoading = false;
    });
    builder.addCase(insertJobApplication.rejected, (state, action) => {
      state.applicationLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActivePosition.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllActivePosition.fulfilled, (state, action) => {
      state.loading = false;
      state.PositionList = action.payload || [];
    });
    builder.addCase(getAllActivePosition.rejected, (state, action) => {
      state.loading = false;
      state.PositionList = [];
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default careerSlice.reducer;
